import { render, staticRenderFns } from "./aboutCooper.vue?vue&type=template&id=26028c65&scoped=true"
import script from "./aboutCooper.vue?vue&type=script&lang=js"
export * from "./aboutCooper.vue?vue&type=script&lang=js"
import style0 from "./aboutCooper.vue?vue&type=style&index=0&id=26028c65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26028c65",
  null
  
)

export default component.exports